import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import Validator from 'validatorjs';

import { Http } from '../../../support';
import LoadingButton from '../../../facturotopia/LoadingButton';
import EmisorFiscalCredentials from '../../../app/emisores/upsert/components/EmisorFiscalCredentials';
import StampingServiceAgreement from '../../../app/emisores/upsert/components/StampingServiceAgreement';
import EmisorFiscalCredentialslInfo from '../../../app/emisores/upsert/components/EmisorFiscalCredentialslInfo';

class ManifiestoFirma extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
      fiscal_credentials: true,
      data: {
        certificados: {}
      }
    };
  }

  get rules() {
    return {
      'certificados.fiel_key': ['required'],
      'certificados.fiel_cer': ['required'],
      'certificados.fiel_password': ['required', 'min:4']
    }
  }

  get inputs() {
    return {
      key: {
        name: 'fiel_key',
        label: 'FIEL .key'
      },
      cer: {
        name: 'fiel_cer',
        label: 'FIEL .cer'
      },
      password: {
        name: 'fiel_password',
        label: 'Contraseña de la FIEL'
      }
    }
  }

  componentDidMount() {
    this.handleOnChange({});
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (event) => {
    const data = {
      data: {
        ...event.data
      },
      isValid: event.isValid
    }

    const validator = this.validate(event.data);

    this.setState({
      ...data,
      isValid: event.isValid && validator.passes()
    });
  }

  submit = () => {
    const { data: { certificados } } = this.state;
    const { params = {} } = this.props.match || {};
    const { search = '' } = this.props.location || {};

    this.setState({
      busy: true
    });

    const certificates = {
      fiel_key: certificados.fiel_key && certificados.fiel_key.value.content,
      fiel_cer: certificados.fiel_cer && certificados.fiel_cer.value.content,
      fiel_password: certificados.fiel_password
    }

    Http.post(`ext/manifiesto/${params.id}${search}`, certificates)
      .then(async (response) => {
        window.ToastManager.show({
          variant: 'success',
          title: 'Completado',
          message: 'Se ha activado tu cuenta exitósamente, inicia sesión.'
        });

        this.setState({
          redirect: true
        });
      }, (error) => {
        this.setState({
          error
        });
      })
      .finally(() => {
        this.setState({
          busy: false
        })
      })
  }

  render() {
    const { busy, data, isValid } = this.state;

    return (
      <>
        <Row>
          <Col sm={ 12} className="py-5">
            <p>
             Para emitir comprobantes fiscales es necesario la firma de la carta consentimiento usando tu FIEL (e-firma). La e-firma es aceptada como una firma válida por el Servicio de Administración Tributaria (SAT) en cumplimiento con la regla 2.7.2.7 de la Resolución Miscelánea Fiscal vigente para la autorización de emisión y envío de comprobantes al SAT.
            </p>

            <p>
              Para proceder con la firma necesitas tener tu FIEL.
            </p>

            { !isValid && (
                <EmisorFiscalCredentials
                  type="FIEL"
                  external={ true }
                  inputs={ this.inputs }
                  terms={ StampingServiceAgreement }
                  data={ data }
                  onFormDataChange={ this.handleOnChange }
                >
                </EmisorFiscalCredentials>
              )
            }

            { isValid && (
                <>
                  <StampingServiceAgreement showAcceptTermsCheckbox={ false } />

                  <hr />

                  <EmisorFiscalCredentialslInfo data={ data } />

                  <hr />
                </>
              )
            }

            <LoadingButton type="button"
                disabled={ !isValid }
                loading={ busy || false }
                onClick={ this.submit }>
                { busy === true ? 'Guardando...' : 'Completar mi registro' }
              </LoadingButton>
          </Col>
        </Row>

      </>
    )
  }
}

export default ManifiestoFirma;